import { SessionRecorder, SessionRecorderEvents } from 'src/types/services/SessionRecorder';

export class SessionRecordingService {
  public isLoaded = false;
  public isClarityLoaded = false;
  public isPosthogLoaded = false;
  public recorders: Record<'clarityRecorder' | 'posthogRecorder', SessionRecorder | null> = {
    clarityRecorder: null,
    posthogRecorder: null,
  };
  private loadingPromise: Promise<void> | null = null;

  public identifyUser = async (id: number, username: string): Promise<void> => {
    if (!this.isLoaded) {
      await this.loadRecorders();
    }

    Object.values(this.recorders).forEach((recorder) => {
      recorder?.identifyUser({ id, username });
    });
  };

  public trackEvent = async (eventName: SessionRecorderEvents, data?: Record<string, any>): Promise<void> => {
    if (!this.isLoaded) {
      await this.loadRecorders();
    }

    Object.entries(this.recorders).forEach(([name, recorder]) => {
      try {
        recorder?.trackEvent(eventName, data);
      } catch (err) {
        console.warn(`[SessionRecorder] "${name}" recorder failed:`, err);
      }
    });
  };

  public loadPosthogRecorder = async (): Promise<void> => {
    if (this.isPosthogLoaded) return;

    this.isPosthogLoaded = true;

    try {
      const posthogModule = await import('../services/posthogRecorder');
      this.recorders.posthogRecorder = new posthogModule.PosthogRecorder();
    } catch (err) {
      console.warn('[SessionRecorder] Posthog recorder failed to load', err);
      this.recorders.posthogRecorder = null;
    }
  };

  public loadClarityRecorder = async (): Promise<void> => {
    if (this.isClarityLoaded) return;

    this.isClarityLoaded = true;

    try {
      const clarityModule = await import('../services/clarityRecorder');
      this.recorders.clarityRecorder = new clarityModule.ClarityRecorder();
    } catch (err) {
      console.warn('[SessionRecorder] Clarity recorder failed to load', err);
      this.recorders.clarityRecorder = null;
    }
  };

  public loadRecorders = async (): Promise<void> => {
    if (this.isLoaded) return;

    if (!this.loadingPromise) {
      this.loadingPromise = (async () => {
        await this.loadClarityRecorder();
        await this.loadPosthogRecorder();
        this.isLoaded = true;
      })();
    }

    return this.loadingPromise;
  };
}

export const sessionRecordingService = new SessionRecordingService();
